module.exports = __webpack_public_path__ + "d5d49cfada8ca08daeb681a04730fd74.svg";